import { css } from '@emotion/core';
import { tokens, rgba } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var button = /*#__PURE__*/css("border:0;background:", rgba(colors.neutral.heavy.default, 0), ";outline:none;padding:0;");
var thumbnail = {
  name: "te8o8m",
  styles: "border:2px solid transparent;transition:border 0.5s;width:52px;height:52px;border-radius:2px;&:not(:first-child){margin-left:12px;}"
};
export var photo = thumbnail;
export var floorplan = thumbnail;
export var video = thumbnail;
export var virtualTour = thumbnail;
export var selected = /*#__PURE__*/css("border:2px solid ", colors.neutral.trim.selected, ";");
export var thumbnails = {
  name: "11jcb1p",
  styles: "text-align:center;white-space:nowrap;"
};
export var photos = {
  name: "17w1n5p",
  styles: "display:inline-block;max-width:360px;white-space:nowrap;"
};
var list = {
  name: "1170n61",
  styles: "vertical-align:bottom;"
};
export var photosList = /*#__PURE__*/css(list, ";", photos, ";width:100%;");
export var floorplanList = /*#__PURE__*/css(list, ";", photos, ";margin-left:48px;");
export var sliderItem = {
  name: "5anaai",
  styles: "position:relative;display:inline-block;width:60px;"
};
export var label = /*#__PURE__*/css(typography.bodySmall, " color:", colors.neutral.subdued.default, ";text-align:left;margin-bottom:1px;height:24px;");